<template>
  <Frontendlayout>
    <section class="hero_in general">
			<div class="wrapper">
				<div class="container">
					<h1 class="fadeInUp"><span></span>{{ userProfile.company_name }}</h1>
				</div>
			</div>
		</section>
    <!-- /hero_single -->
    <div class="bg_color_1">

      <div class="container margin_60_35">
        <div class="row">
          <div class="col-lg-8">
            <section id="description">
              <h4>Marchant Profile</h4>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <a :href="`https://peekzy.in/backend/public/assets/uploads/${userProfile.profile_image}`"
                    title="Photo title" data-effect="mfp-zoom-in">
                    <img style="width: 100%;height: 288px;padding: 20px;border: 1px solid #dedede;border-radius: 5px;"
                      :src="`https://peekzy.in/backend/public/assets/uploads/${userProfile.profile_image}`" />
                    <!-- <img style="width: 100%;height: 288px;padding: 20px;border: 1px solid #dedede;border-radius: 5px;" src="https://peekzy.in/backend/public/assets/uploads/Free-new-wallpaper-hd.jpg" /> -->
                  </a>
                </div>
                <div class="col-md-8">
                  <ul class="list-group">
                    <li class="list-group-item"><label>Name : </label> {{ userProfile.name }}</li>
                    <li class="list-group-item"><label>Email ID :</label> <a :href="'mailto:' + userProfile.email">{{
                        userProfile.email
                    }}</a></li>
                    <li class="list-group-item"><label>Pan Card :</label> {{ userProfile.pancard }}</li>
                    <li class="list-group-item"><label>GSTIN :</label> {{ userProfile.gst }}</li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-6"><a class="btn_1 full-width purchase" :href="'tel:' + userProfile.mobile_1">
                            <i class="icon_phone"></i> Call</a></div>
                        <div class="col-md-6"><a href="#" class="btn_1 full-width outline wishlist"><i
                              class="icon-chat-5"></i> Chat</a></div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="col-md-12">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <div v-html="userProfile.about_us" class="col-md-12 mt-3"></div>
                    </li>
                  </ul>
                </div>
                <hr>

                <div class="row">
                  <div class="col-lg-6" v-for="category in userProfile.categories" :key="category.category_id">
                    <ul class="bullets">
                      <li>{{ category.category }}</li>
                    </ul>
                  </div>
                </div>
              </div>

            </section>

          </div>
          <!-- /col -->

          <aside class="col-lg-4" id="sidebar">
            <div class="box_detail booking">

              <form @submit.prevent="openLoginModal()">
                <div class="form-group">
                  <label for="Offer">Mobile Number</label>
                  <input class="form-control" v-model="custMobile" required type="text" />
                </div>
                <div class="form-group">
                  <label for="Offer Summary">Customer Summary</label>
                  <textarea class="form-control" v-model="custSummary" required rows="4" cols="50"></textarea>
                </div>
                <button class="btn_1 full-width purchase">Deal With Marchant</button>
              </form>


              <!-- <div class="text-center">
                <small>No money charged in this step</small>
              </div> -->
            </div>

          </aside>
          <div class="col-md-12" v-if="galleries.length > 0">
            <div class="main_title_2">
              <span><em></em></span>
              <h2>Here some pictures ...</h2>
              <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
            </div>
            <div class="grid">
              <ul class="magnific-gallery">
                <li @click="checkImagePopup();" v-for="gallery in galleries" :key="gallery.id">
                  <figure>
                    <img :src="`https://peekzy.in/backend/public/assets/user/vendorgallery/${gallery.link}`" alt="">
                    <figcaption>
                      <div class="caption-content">
                        <a :href="`https://peekzy.in/backend/public/assets/user/vendorgallery/${gallery.link}`"
                          data-effect="mfp-zoom-in">
                          <i class="pe-7s-albums"></i>
                          <p>View</p>
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </li>
              </ul>
            </div>
            <!-- /grid gallery -->
          </div>

<div class="col-md-12" v-if="userProfile.video1 || userProfile.video2 || userProfile.video3">
          <div class="bg_color_1">
            <div class="container margin_60_35">
              <div class="main_title_2">
                <span><em></em></span>
                <h2>Here some videos ...</h2>
                <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
              </div>
              <div class="grid">
                <ul class="magnific-gallery">
                  <li v-if="userProfile.video1" @click="checkImagePopup();">
                    <figure>
                      <img src="https://peekzy.in/backend/public/assets/uploads/videoplay.png" alt="">
                      <figcaption>
                        <div class="caption-content">
                          <a :href="userProfile.video1"   class="video">
                            <i class="pe-7s-film"></i>
                            <p>View Video</p>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </li>

                  <li v-if="userProfile.video2" @click="checkImagePopup();">
                    <figure>
                      <img src="https://peekzy.in/backend/public/assets/uploads/videoplay.png" alt="">
                      <figcaption>
                        <div class="caption-content">
                          <a :href="userProfile.video2"  class="video">
                            <i class="pe-7s-film"></i>
                            <p>View Video</p>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </li>
                  <li v-if="userProfile.video3" @click="checkImagePopup();">
                    <figure>
                      <img src="https://peekzy.in/backend/public/assets/uploads/videoplay.png" alt="">
                      <figcaption>
                        <div class="caption-content">
                          <a :href="userProfile.video3" class="video">
                            <i class="pe-7s-film"></i>
                            <p>View Video</p>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </li>
                </ul>
              </div>
              <!-- /grid -->
            </div>
            <!-- /container -->
          </div>
</div>
          <div class="col-md-12">
            <div class="main_title_2">
              <span><em></em></span>
              <h2>Active Offers ...</h2>
              <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
            </div>
            <div class="isotope-wrapper" v-if="offerList.length > 0">
              <div class="row">
                <div class="col-md-4 isotope-item popular" v-for="offer in offerList" :key="offer.id">
                  <div class="box_grid">
                    <figure>
                      <small>{{ userProfile.company_name }}</small>
                      <a :href="'/offer-post-single/' + offer.id"><img :src="
                        'https://peekzy.in/backend/public/assets/uploads/offer-images/' +
                        offer.image
                      " class="img-fluid" :alt="userProfile.company_name" width="800" height="533" />
                        <div class="read_more"><span>View Profile</span></div>
                      </a>
                    </figure>
                    <div class="wrapper">
                      <a href="#0" class="wish_bt"></a>
                      <h3>
                        <a :href="'/offer-post-single/' + offer.id">{{
                            offer.short_description
                        }}</a>
                      </h3>

                      <!-- <div v-html="offer.description">
              {{ offer.description }}
            </div> -->
                      <p class="location">
                        <span class="col-md-6 pull-left">
                          <i class="fa fa-map-marker"></i> {{ offer.pincode }}
                        </span>
                        <span class="col-md-6 pull-right">
                          <i class="fa fa-map"></i> {{ offer.location }}
                        </span>
                      </p>
                      <span class="price" v-if="offer.offer_in == 'percent'">
                        Discount Upto <strong>{{ offer.offer_value }}%</strong>
                      </span>
                      <span class="price" v-else>
                        Upto
                        <strong><i class="fa fa-inr"></i> {{ offer.offer_value }}</strong>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <i class="icon_clock_alt"></i> <b>Validity:</b>
                        {{ validity(offer.valid_till) }}
                      </li>
                      <li>
                        <div class="score">
                          <span>Superb<em>0 Reviews</em></span><strong>10</strong>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="box_list isotope-item popular">
                <div class="row no-gutters">
                  <div class="col-lg-12">
                    <center>
                      <h5 class="mt-3">No Offer Found.</h5>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
      <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <Signin />
          </div>
        </div>
      </div>
    </div>
    <!-- /bg_color_1 -->
  </Frontendlayout>
</template>

<script>
/* eslint-disable */

import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import { EventBus } from "@/EventBus";
import Signin from "../components/Signin";

export default {
  created() {
    EventBus.$on("emittedData", (data) => {
      console.log("filter pincode:" + data.search.pincode);
      this.catOptions = data.catList;
      this.subCatOptions = data.subCatList;
    });
  },
  data() {
    return {
      userProfile: {
        company_name: "",
        name: "",
        email: "",
        mobile_1: "",
        gst: "",
        pancard: "",
        about_us: "",
        video1:"",
        video2:"",
        video3:"",
        profile_image: "",
        categories: [],
      },
      offerList: [],
      galleries: [],

      custSummary: '',
      custMobile: '',
    };
  },
  beforeMount() {
    this.getUserProfile();
  },
  mounted() {
    this.checkImagePopup();
  },
  components: {
    Frontendlayout, Signin,
  },
  methods: {

    checkImagePopup() {
      window.$('.video').magnificPopup({type:'iframe'});
      window.$('.magnific-gallery').each(function () {
        window.$(this).magnificPopup({
          delegate: 'a',
          type: 'image',
          preloader: true,
          gallery: {
            enabled: true
          },
          removalDelay: 500, //delay removal by X to allow out-animation
          callbacks: {
            beforeOpen: function () {
              // just a hack that adds mfp-anim class to markup 
              this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
              this.st.mainClass = this.st.el.attr('data-effect');
            }
          },
          closeOnContentClick: true,
          midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
        });
      });
    },
    openLoginModal: function () {
      console.log(this.$route.params);
      const token = localStorage.getItem("token");
      const roleId = localStorage.getItem("role_id");
      if (token != null) {
        if (roleId != 2) {
          const form = new FormData();
          form.append("customer_mobile", this.custMobile)
          form.append("customer_summary", this.custSummary)
          API.post(`/search/offerSingleForm/${this.$route.params.slug}`, form, {
            headers: { Authorization: "Bearer " + token },
          })
            .then((res) => {
              if (res.data.status == 200) {
                this.$swal("success	", res.data.message);
                this.$router.push({ name: 'MerchantProfile' })
              } else {
                this.$swal(res.data.message);

              }
            })
            .catch((err) => {
              console.log(err.response);
            });
        } else {
          this.$swal("Error", "Only For Customer");
        }
      } else {
        window.$('.bd-example-modal-lg').modal('show')
      }
    },
    validity(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },
    getUserProfile() {
      const firstSegment = new URL(location.href).pathname.split("/")[1];
      const lastSegment = new URL(location.href).pathname.split("/")[3];

      const form = new FormData();
      //alert($(".childcat").is(":checked").val());
      form.append("profile_id", lastSegment);
      form.append("role", firstSegment);

      API({
        method: "post",
        url: "/search/marchantProfile",
        data: form,
        auth: {
          username: "testclient",
          password: "testsecret",
        },
      }).then((res) => {
        if (res.data.status == 200) {

          this.userProfile.company_name = res.data.data.company_name;
          this.userProfile.name = res.data.data.first_name + ' ' + res.data.data.last_name;
          this.userProfile.email = res.data.data.primary_email;
          this.userProfile.mobile_1 = res.data.data.mobile_1;
          this.userProfile.pancard = res.data.data.pan_no;
          this.userProfile.gst = res.data.data.gst_no;
          this.userProfile.about_us = res.data.data.about_us;
          this.userProfile.profile_image = res.data.data.profile_img;
          this.userProfile.video1 = res.data.data.video1;
          this.userProfile.video2 = res.data.data.video2;
          this.userProfile.video3 = res.data.data.video3;
          this.userProfile.categories = res.data.data.categories;

          this.offerList = res.data.data.offers;
          this.galleries = res.data.data.galleries;

        } else {
          this.$swal("Error", res.data.messages);
        }
      });
    },
  },
};
</script>


<style  scoped>
@import "../../public/frontend/css/custom.css";
</style>